// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--Wa9j3","description":"dece2e673c--description--NJiwG"};